import { render, staticRenderFns } from "./PriceQualityReport.vue?vue&type=template&id=71684a5f&scoped=true&"
import script from "./PriceQualityReport.vue?vue&type=script&lang=js&"
export * from "./PriceQualityReport.vue?vue&type=script&lang=js&"
import style0 from "./PriceQualityReport.vue?vue&type=style&index=0&id=71684a5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71684a5f",
  null
  
)

export default component.exports